import { Injectable, OnDestroy, inject } from '@angular/core';
import {HeartBeatApi} from '../api/heart-beat.api';
import {EMPTY, Subscription, timer} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HeartBeatService implements OnDestroy {
  private heartBeatApi = inject(HeartBeatApi);

  private initialDelay = 1000;
  private interval = 30000;
  private heartbeatSubscription?: Subscription;

  constructor() {
    this.startBeating();
  }

  public startBeating(): void {
    // Clean up existing subscription if any
    if (this.heartbeatSubscription) {
      this.heartbeatSubscription.unsubscribe();
    }

    // Use switchMap to properly manage nested subscriptions
    this.heartbeatSubscription = timer(this.initialDelay, this.interval)
      .pipe(
        switchMap(() => this.heartBeatApi.beat()),
        catchError(error => {
          // Error occurred
          if (error.status === 0) {
            // No connection?
            console.error('Internet connection failed, please check your connection');
          } else if (error.status === 403) {
            console.error('Not allowed');
          } else {
            console.error(error.message);
          }
          return EMPTY;
        })
      )
      .subscribe(() => {
        // Successful beat
      });
  }

  public stopBeating(): void {
    if (this.heartbeatSubscription) {
      this.heartbeatSubscription.unsubscribe();
      this.heartbeatSubscription = undefined;
    }
  }

  ngOnDestroy(): void {
    this.stopBeating();
  }
}
